import PropTypes from 'prop-types';
import React from 'react';

export const FlagWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'FLAG',
    category: 'Setup',
    type: 'Flag',
    domain: 'Underlying',
  };
  /*
  {
 	"messageType": "softOrder",
 	"tradePlanId": 0,
 	"value": {
 		"timeStamp": "1634317499268",
 		"tacticId": "FLAG|BASIC_TRADING_SYSTEM16343174981741",
 		"tactic": "FLAG",
 		"symbol": "XYZ",
 		"tacticValue": {"FLAG":{"BREAK_LOW":{"priceToBreak":99.9}},"breakBy":0.1,"patterns":[[{"candleSequence":"BREAK_LOW","terminateOnFail":true,"restartOnFail":false,"currentSequence":false},{"candleSequence":"FAIL_TO_BREAK_LOW","terminateOnFail":false,"restartOnFail":false,"currentSequence":false},{"candleSequence":"BREAK_LOW","terminateOnFail":false,"restartOnFail":false,"currentSequence":true}]]} 	}
 }
  */
  return (
    <Component
      details={details}
      flagPattern={softOrder}
      {...rest}
    />
  );
};

FlagWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.any
};
